/* jshint esversion: 6 */
/* global, document, window */

// import '@babel/polyfill';
// import initFonts from './scripts/fonts';
import pollyfill from './scripts/polyfill';

import promotionInit from './components/promotion';

function load() {
    if (!document.cookie.match(`(^|;) ?_kfl=([^;]*)(;|$)`)) {
    //    import(/* webpackMode: "lazy", webpackChunkName: "fontLoader", webpackPreload: true */'./scripts/fonts').then(({ default: initFonts }) => initFonts());
    }
    else {
     //   document.body.classList.add('fonts-loaded');
    }

    import(/* webpackMode: "lazy", webpackChunkName: "jquery", webpackPreload: true */'jquery').then(({ default: jQuery }) => {
        window.$ = jQuery;
        window.jQuery = jQuery;
        promotionInit();
        return Promise.all([
            import(/* webpackChunkName: "lazyLoad", webpackPreload: true */'./scripts/lazyLoad'),
            import(/* webpackChunkName: "product", webpackPreload: true */'./components/product'),
        ]).then(() => Promise.all([
            import(/* webpackChunkName: "common", webpackPreload: true */'./components/common'),
            import(/* webpackChunkName: "navigation", webpackPreload: true */'./components/navigation')
        ]).then(() => {


            import(/* webpackChunkName: "moduleLoader", webpackPreload: true */'./scripts/moduleLoader').then(({ default: moduleLoader }) => {
                const $productBox = $('<section class="page-product-box"></section>');
                $('#comments-module').append($productBox);

                moduleLoader.addModule('commentsModule', $productBox, ['displayProductTabContent']).then(l => import(/* webpackChunkName: "commentsModule" */'./components/commentsModule').then(_ => l(_)));
                moduleLoader.addModule('crossselling', $('.similar-product-list'), 'displaySimilarProducts').then(l => import(/* webpackChunkName: "crosseling" */'./components/crossselling').then(_ => l(_)));
            //    moduleLoader.addModule('footerModule', $('.product-footer'), 'displayFooterProduct').then(l => import(/* webpackChunkName: "footerModule" */'./components/footerModule').then(_ => l(_)));
                moduleLoader.addModule('footer', $('.footer-container'), false).then(l => import(/* webpackChunkName: "footer" */'./components/footer').then(_ => l(_)));

            });


            import(/* webpackChunkName: "_product_modules_", webpackPreload: true */'./modules/front');
            import(/* webpackChunkName: "fbchat", webpackPreload: true */'./components/fbchat').then(({ default: initdbchat }) => initdbchat());

        }));
    });
}

pollyfill(() => {
    const raf = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
    if (raf) {
        raf(() => {
            window.setTimeout(load, 0);
        });
    }
    else {
        window.addEventListener('load', load);
    }
});
